module.exports = __webpack_public_path__ + "img/funNew.303f89ae.png";